<div mat-dialog-content>
  <div class="mat-dialog-content">
    <div class="img-head-modal">
      <img src="assets/images/exclamation-circle.png" />
    </div>
    <div class="title-modal">
      <h1><b>Atenção!</b></h1>
    </div>

    <div class="body-modal">
      @if (!this.data.isAllergySelection) {
        <p>O paciente é alérgico a um dos princípios ativos deste medicamento.</p>
      }
      @if (this.data.isAllergySelection) {
        <p>O paciente já possui uma prescrição ou solução com o princípio ativo da alergia selecionada.</p>
      }
      @if (!this.data.blockAllergicPrescription && !this.data.isAllergySelection) {
        <p>Deseja prosseguir com a prescrição?</p>
      }
      @if (!this.data.blockAllergicPrescription && this.data.isAllergySelection) {
        <p>Deseja prosseguir com a inclusão da alergia?</p>
      }
      @if (this.data.blockAllergicPrescription && !this.data.isAllergySelection) {
        <p>Prescrição bloqueada!</p>
      }
      @if (this.data.blockAllergicPrescription && this.data.isAllergySelection) {
        <p>Inclusão de alergia bloqueada!</p>
      }
    </div>
    <div class="footer-modal">
      @if (!this.data.blockAllergicPrescription) {
        <button mat-flat-button color="accent" class="btn-block btn-confirm" (click)="clickConfirm()" [color]="buttonColor">
          <span>Sim</span>
        </button>
      }
      <button mat-flat-button color="accent" class="btn-block btn-cancel" (click)="clickCancel()">
        @if (!this.data.blockAllergicPrescription) {
          <span>Não</span>
        }
        @if (this.data.blockAllergicPrescription) {
          <span>Sair</span>
        }
      </button>
    </div>
    @if (this.confirm) {
      <div class="justification-content">
        <form class="form" [formGroup]="model" (ngSubmit)="onSubmit()">
          <div class="row">
            <div class="col-12">
              <mat-form-field appearance="outline">
                <mat-label>Justificativa</mat-label>
                <textarea matInput formControlName="justification"></textarea>
                @if (model.get('justification').invalid) {
                  <mat-error>Informe a justificativa</mat-error>
                }
              </mat-form-field>
            </div>
          </div>
          <div class="footer-modal">
            <button mat-flat-button type="submit" color="primary" class=" btn-block">
              <span>Concluir</span>
            </button>
          </div>
        </form>
      </div>
    }
  </div>
</div>

